<section class="list-teachers max-w-100">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-auto">
                <h3 class="title">{{ capacitationTitle }}</h3>
            </div>
            <div class="col-12 col-lg-4">
                <nb-form-field>
                    <input
                        nbInput
                        fullWidth
                        nbPreffix
                        #input
                        type="text"
                        (keyup)="onInputChange$.next(input.value)"
                        placeholder="{{ 'GENERAL.SEARCH-BY-NAME' | translate }}"
                    />
                    <nb-icon icon="search" nbSuffix></nb-icon>
                </nb-form-field>
            </div>
            <div class="col-12">
                <hr class="divider" />
            </div>
        </div>

        <div class="row">
            <!-- prettier-ignore -->
            <div
                class="col-lg-12 mb-4"
                *ngFor=" let teacher of registers"
            >
                <div class="teacher">
                    <div class="teacher-image">
                        <img
                            [src]="teacher.url_avatar"
                            [alt]="teacher.nome_completo"
                        />
                    </div>
                    <div class="col-lg-4">
                        <p>
                            <span class="label">Nome</span
                            >{{ teacher.nome_completo }}
                        </p>
                    </div>
                    <div class="col-lg-2 ml-auto">
                        <p>
                            <span class="label">Cidade</span
                            >{{ teacher.cidade }}
                        </p>
                    </div>
                    <div class="col-auto">
                        <p><span class="label">Estado</span>{{ teacher.uf }}</p>
                    </div>
                    <div class="col-lg-3">
                        <span class="label">Graduação</span>
                        <p>{{ teacher.graduacao }}</p>
                    </div>

                </div>
            </div>
        </div>

        <app-shared-pagination
            [perPage]="perPage"
            [size]="total"
            (onChange)="onPageChange($event)"
            *ngIf="total > 0"
        ></app-shared-pagination>

        <app-no-results *ngIf="statusCode > 0 && !registers"></app-no-results>
    </div>
</section>
